import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {moduloHorasExtras} from "../../diccionarios/horas-extrasModulo";
import {ParametrizacionFechaCorteService} from "../../services/parametrizacion-fecha-corte.service";
import * as _ from 'lodash';

@Component({
  selector: 'app-parametrizacion-fecha-corte',
  templateUrl: './parametrizacion-fecha-corte.component.html',
  styleUrls: ['./parametrizacion-fecha-corte.component.css']
})
export class ParametrizacionFechaCorteComponent implements OnInit {

  mostrarFormulario: boolean = false;
  mostrarGridLista: boolean = true;
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  obligatorylocality: boolean = false;
  today: any;


  constructor(
    private fb: FormBuilder,
    private _parametrizacionFechaCorteService: ParametrizacionFechaCorteService,
    private _util: UtilsService,
  ) {
    this.diccionarioModulo = moduloHorasExtras;
  }

  ngOnInit(): void {
    this.DAT_BTNS = moduloHorasExtras.button.buttonsNombre;
    this.DAT_TITULOS = moduloHorasExtras.titulos.parametrizacionFechaCorte;
    this.DAT_BTNCSS = moduloHorasExtras.button.buttonsCss;
    this.DAT_MSG = moduloHorasExtras.mensajes;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.formulario = this.fb.group({
      id: [''],
      dia: ['', [Validators.required, Validators.min(1), Validators.max(28)]],
      diaHasta: ['', [Validators.required, Validators.min(1), Validators.max(28)]],
    });
    this.girdComponent();
    this.getAllDias();
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getAllDias() {
    this.loading = true;
    this._parametrizacionFechaCorteService.getAll().subscribe((res: any) => {
      const resList = new Array(res);
      this.rowData = resList;
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowData = [];
    });
  }


  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'DÍA INICIO',
        field: 'dia',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'DÍA FIN',
        field: 'diaHasta',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editarFechaCorte.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
    ];
    this.rowSelection = 'single';
  }

  editarFechaCorte({rowData}) {
    this.titulo = this.DAT_TITULOS.tituloCardEditar;
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.editar;
    this.editableForm = true;
    rowData.dia = rowData.dia ? rowData.dia : 1;
    rowData.diaHasta = rowData.diaHasta ? rowData.diaHasta : 1;
    this.formulario.setValue(rowData);
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizarFechaCorte();
      } else {
      }
    } else {
      this.titulo = this.DAT_TITULOS.tituloCardListar;
      this.mostrarGridLista = true;
    }
  }

  actualizarFechaCorte() {
    let payload = _.cloneDeep(this.formulario.value);
    payload.dia = parseInt(payload.dia);
    payload.diaHasta = parseInt(payload.diaHasta);
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: ``,
        action: this.DAT_BTNS.editar,
        funcion: this._parametrizacionFechaCorteService.actualizarFechaCorte(payload),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getAllDias();
      this.regresar();
    });
  }


  regresar() {
    this.formulario.reset();
    this.mostrarGridLista = true;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }
}
